import Icon from "@Atom/Icon";
import { NavLink, useNavigate } from "react-router-dom";
import Styles from "../navbar.module.scss";
import { useState } from "react";

export default function OtherClientNavbar({
  active,
  activeInfo,
  // onHover,
  width,
}) {
  const [hover, setHover] = useState("");

  const navigate = useNavigate();

  const list = [
    {
      id: 1,
      name: "Daftar Loker",
      path: "/business/dashboard/job-list",
      activeInfo: "job-list",
      icon: "briefcase-v2",
    },
    {
      id: 2,
      name: "Cari Kandidat",
      path: "/business/dashboard/candidate-list",
      activeInfo: "candidate-list",
      icon: "people-v2",
    },
    {
      id: 3,
      name: "Profil Perusahaan",
      path: "/business/dashboard/company-profile",
      activeInfo: "company-profile",
      icon: "buildings-v2",
    },
  ];

  return (
    <div className={Styles.navWrapper}>
      {list?.map((el, ids) => {
        return (
          <div
            className={Styles.nav}
            key={ids}
            onMouseEnter={() => {
              setHover(el?.id);
            }}
            onMouseLeave={() => {
              setHover("");
            }}
            onClick={() => {
              navigate(el?.path);
            }}
          >
            {activeInfo[3] === el?.activeInfo && (
              <div className={Styles.line}></div>
            )}
            <Icon
              icon={el?.icon}
              color={
                activeInfo[3] === el?.activeInfo || hover === el?.id
                  ? "#2E3192"
                  : "#A9B3C1"
              }
              size={24}
            />
            {width <= 768 && (
              <span
                className={`${Styles.span} ${
                  activeInfo[3] === el?.activeInfo || hover === el?.id
                    ? Styles.active
                    : null
                }`}
              >
                {el?.name}
              </span>
            )}

            <div
              className={`${Styles.hoverBox} ${
                width > 768 &&
                hover === el?.id &&
                active !== el?.id &&
                Styles.hovered
              }`}
            >
              <span>{el?.name}</span>
              <div className={Styles.tooltipArrow}></div>
            </div>
          </div>
        );
      })}
      {/* <div className={Styles.nav}>
        {activeInfo[3] === "job-list" && <div className={Styles.line}></div>}
        <Icon
          icon={"briefcase-v2"}
          color={activeInfo[3] === "job-list" ? "#2E3192" : "#A9B3C1"}
          size={24}
        />
        {width <= 768 && (
          <span
            className={`${Styles.span} ${
              activeInfo[3] === "job-list" && Styles.active
            }`}
          >
            Daftar Loker
          </span>
        )}
      </div>
      <div className={Styles.nav}>
        {activeInfo[3] === "candidate-list" && (
          <div className={Styles.line}></div>
        )}
        <Icon
          icon={"people-v2"}
          color={activeInfo[3] === "candidate-list" ? "#2E3192" : "#A9B3C1"}
          size={24}
        />

        {width <= 768 && (
          <span
            className={`${Styles.span} ${
              activeInfo[3] === "candidate-list" && Styles.active
            }`}
          >
            Cari Kandidat
          </span>
        )}
      </div>
      <div className={Styles.nav}>
        {activeInfo[3] === "company-profile" && (
          <div className={Styles.line}></div>
        )}
        <Icon
          icon={"buildings-v2"}
          color={activeInfo[3] === "company-profile" ? "#2E3192" : "#A9B3C1"}
          size={24}
        />
        {width <= 768 && (
          <span
            className={`${Styles.span} ${
              activeInfo[3] === "company-profile" && Styles.active
            }`}
          >
            Profil Perusahaan
          </span>
        )}
      </div> */}
    </div>
  );
}
